// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type SelfUserFlagQueryQueryVariables = Types.Exact<{
  displayFlag?: Types.InputMaybe<Types.UserFlagsDisplayFlag>;
}>;

export type SelfUserFlagQueryQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Viewer';
    id: string;
    selfUserFlagDetails?: {
      __typename?: 'UserFlagDetails';
      title?: string | null;
      body?: Array<string | null> | null;
      action?: {
        __typename?: 'UserFlagDetailsAction';
        text: string;
        url?: string | null;
        urn?: string | null;
        trackingId?: string | null;
      } | null;
    } | null;
  } | null;
};

export const SelfUserFlagQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SelfUserFlagQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'displayFlag' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UserFlagsDisplayFlag' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selfUserFlagDetails' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'displayFlag' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'displayFlag' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'platform' },
                      value: { kind: 'EnumValue', value: 'WEB' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'action' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'urn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'trackingId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SelfUserFlagQueryQuery,
  SelfUserFlagQueryQueryVariables
>;
